export function firestoreEventKind(event) {
  return event?.kind || event?.type || "unknown";
}

export function sanitizeFirestorePath(path) {
  if (typeof path !== "string") return path;
  const parts = path.split("/");
  for (let index = 0; index < parts.length - 1; index += 1) {
    if (parts[index] === "webTokens" || parts[index] === "nativeTokens") {
      parts[index + 1] = "[redacted]";
    }
  }
  return parts.join("/");
}

export function summarizeFirestoreEvents(events = []) {
  const rows = Array.isArray(events) ? events : [];
  const summary = {
    activeListeners: 0,
    listenerStarts: 0,
    listenerStops: 0,
    initialDocuments: 0,
    deltaDocuments: 0,
    readDocuments: 0,
    writes: 0,
    timedOperations: 0,
    averageDurationMs: 0,
    cacheEvents: 0,
    serverEvents: 0,
    other: 0,
  };
  let durationTotal = 0;

  for (const event of rows) {
    const kind = firestoreEventKind(event);
    const size = Number.isFinite(event?.size) ? Math.max(0, event.size) : 0;

    if (kind === "listen:start") {
      summary.listenerStarts += 1;
    } else if (kind === "listen:stop") {
      summary.listenerStops += 1;
    } else if (kind === "listen:init") {
      summary.initialDocuments += size;
    } else if (kind === "listen:delta") {
      summary.deltaDocuments += size;
    } else if (kind.startsWith("read:")) {
      summary.readDocuments += size;
    } else if (kind.startsWith("write:")) {
      summary.writes += 1;
    } else if (kind !== "listen:error") {
      summary.other += 1;
    }

    if (Number.isFinite(event?.open)) {
      summary.activeListeners = Math.max(0, event.open);
    }
    if (Number.isFinite(event?.durationMs)) {
      summary.timedOperations += 1;
      durationTotal += Math.max(0, event.durationMs);
    }
    if (event?.source === "cache") summary.cacheEvents += 1;
    if (event?.source === "server") summary.serverEvents += 1;
  }

  if (!rows.some((event) => Number.isFinite(event?.open))) {
    summary.activeListeners = Math.max(0, summary.listenerStarts - summary.listenerStops);
  }
  if (summary.timedOperations > 0) {
    summary.averageDurationMs = Math.round((durationTotal / summary.timedOperations) * 10) / 10;
  }

  return summary;
}
